import { urls } from "../Urls";
import { Http } from "../Http";
import { getEnvVariable } from "../../environments/env";
import { HttpTemp } from "../Http-temp";
export class ApplicationApi {
  // static getregisterdApps(payerID:any,environment:string,pageNumber:number,pageSize:number){
  //   const url = urls.applications.getRegisterApplicaiton(payerID,environment,pageNumber,pageSize)
  //   return Http.get(url)
  // }
  static getregisterdApps(
    payerID: any,
    environment: string,
    pageNumber: number,
    pageSize: number,
    applicationName?:string,
    applicationStatus?:number
  ) {
    const url = urls.applications.getRegisterApplicaiton(
      payerID,
      environment,
      pageNumber,
      pageSize,
      applicationName,
      applicationStatus
    );
    return HttpTemp.get(url);
  }

  static getApplictionById(id: number) {
    const url = urls.applications.getApplicationById(id);
    return HttpTemp.get(url);
  }
  static getPayerMemeberList(
    MemberID?: any,
    FirstName?: string,
    LastName?: string,
    DOB?: any,
    Email?: string,
    PageNumber?: any,
    PageSize?: any,
  ) {
    const url = urls.applications.getPayerMembers(
      MemberID,
      FirstName,
      LastName,
      DOB,
      Email,
      PageNumber,
      PageSize,
    );
    return Http.get(url);
  }
  static getPortalUserList(
    FirstName?: any,
    LastName?: any,
    UserName?: any,
    Email?: any,
    IsActive?: any,
    PageNumber?: any,
    PageSize?: any,
    UserRole?: any,
  ) {
    const url = urls.applications.getPortalUsersList(
      FirstName,
      LastName,
      UserName,
      Email,
      IsActive,
      PageNumber,
      PageSize,
      UserRole,
    );
    return Http.get(url);
  }
  static getUserRole() {
    return Http.get(urls.applications.getUserRoles);
  }
  static getUserByID(id: any) {
    const url = urls.applications.getUserByID(id);
    return Http.get(url);
  }
  static getUserBySSOID(id: string) {
    const url = urls.applications.getMemberBySSOID(id);
    return Http.get(url);
  }
  static getUserByEmail(email: any) {
    const url = urls.applications.getUserByEmail(email);
    return Http.checkEmailExistence(url);
  }

  static createClient(data: any) {
    const updateStatusUri = `${getEnvVariable().base_url}/SSO/CreateClient `;
    return Http.post(updateStatusUri, data);
  }

  static updateApplicationStatus(data: any) {
    const updateStatusUri = `${getEnvVariable().temp_base_url}/SSO/UpdateRegisteredApp  `;
    return HttpTemp.put(updateStatusUri, data);
  }

  static createNewUser(data: object) {
    return Http.post(urls.applications.createUser, data);
  }

  static updateUserDetails = (data: Object) => {
    return Http.put(urls.applications.updateUser, data);
  };
  static sendEmail(data: any) {
    const url = urls.applications.sendEmail??"";
    const onyxUrl = urls.applications.sendOnyxEmail??"";
    if (data) {
      data?.append("CustomerID", process.env.REACT_APP_PAYER_ID);
      data?.append("ConsumerSecret", process.env.REACT_APP_CONSUMER_SECRET);
    }
    if (!url && !onyxUrl) {
      throw new Error("sendEmail URL is not defined");
    }
    if(onyxUrl) {
      Http.post(onyxUrl, data, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }).then((response)=>{
      if(response && response.isSuccess){
        return response;
      }
      if (url) {
        Http.post(url, data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }).then((response) => {
          if (response && response.isSuccess) {
            return response;
          }
        });
      }
    })
  }
}
}
